exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".title__Fields-module___2Xv4y {\n  margin-bottom: 8px;\n}\n\n.wrapper__Fields-module___ASIMV {\n  position: relative;\n}\n\n.hBox__Fields-module___3IMlf {\n  width: 100%;\n  display: flex;\n  justify-content: start;\n  align-items: center;\n}\n\n.mark__Fields-module___2Ot4a {\n  position: absolute;\n  left: 60px;\n  top: -10px;\n}\n\n.buttonNew__Fields-module___3nqxU {\n  margin-top: 8px;\n}\n", ""]);

// Exports
exports.locals = {
	"title": "title__Fields-module___2Xv4y",
	"wrapper": "wrapper__Fields-module___ASIMV",
	"hBox": "hBox__Fields-module___3IMlf",
	"mark": "mark__Fields-module___2Ot4a",
	"buttonNew": "buttonNew__Fields-module___3nqxU"
};